import { gql } from '@apollo/client';

export const HANDLE_PICKUP_FAILED = gql`
  mutation HandlePickupFailed($input: HandlePickupFailedInput!) {
    handlePickupFailed(input: $input)
  }
`;
export interface HandlePickupFailedInput {
  appointmentId: string;
  taskId: string;
  failedReason: string;
  exceptionPhotosS3KeysJson: string[];
  actualPickupDate: string,
  actualPickupTimeEnd: string;
  cooperationWarehouseId?: string;
}
export interface HandlePickupFailedResponse {
  handlePickupFailed: boolean;
}
